module.exports = __webpack_public_path__ + "static/media/MVMLogo175.66bf78a1.jpg";